<template>
  <div></div>
</template>

<script>
export default {
  name: "AuthXPreviewWidget",
  props: {
    appId: {
      type: [String, Number],
      required: true
    },
    clientId: {
      type: String,
      required: true
    }
  },

  beforeMount() {
    const origin = window.location.origin;
    const redirect = this.$router.resolve({
      name: "authx.preview.redirect",
      params: { id: this.appId }
    });
    let script = document.createElement("script");

    const URL =
      process.env.NODE_ENV === "production"
        ? "https://ajs.radius.africa/authx.js"
        : "https://staging-ajs.radius.africa/authx.js";
    script.setAttribute("src", URL);
    script.onload = () => {
      // eslint-disable-next-line no-undef
      window["authx"] = AuthX(this.clientId, {
        mode: "sandbox",
        redirect_uri: origin + redirect.href,
        locale: "en",
        isSpa: true,
        isDev: true,
        onComplete: (session, message) => {
          console.log("Logged in ", session, message);
        },
        onError: error => {
          this.notification("Error", error.message, "danger");
        }
      });
    };

    document.head.appendChild(script);
  }
};
</script>
